import { render, staticRenderFns } from "./SettingsStageBestOfThird.vue?vue&type=template&id=0d5b7fb4&"
import script from "./SettingsStageBestOfThird.vue?vue&type=script&lang=js&"
export * from "./SettingsStageBestOfThird.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports